import React from "react";
import {
  Box,
  Button,
  Grid,
  makeStyles,
  TextField,
  Typography,
  InputAdornment,
} from "@material-ui/core";
import { VisibilityOffOutlined, VisibilityOutlined } from "@material-ui/icons";
import { Auth } from "aws-amplify";
import { useState, useContext } from "react";
import { Link, useHistory, withRouter } from "react-router-dom";
import awsconfig from "../../aws-exports";
import Amplify from "@aws-amplify/core";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
// import { AuthContext } from "../../Context/Auth";
import LoadingScreen from "../../Shared/LoadingScreen";
import { AuthContext } from "../../Context/Auth";
import { log } from "react-modal/lib/helpers/ariaAppHider";

Amplify.configure(awsconfig);

const useStyles = makeStyles({
  img: {
    width: "100%",
    height: "100vh",
    backgroundSize: "cover",
  },
  form: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  input: {
    marginTop: "30px",
    width: "50%",
  },
  button: {
    width: "50%",
    marginTop: "30px",
    backgroundColor: "#5555b2",
    color: "white",
    fontWeight: "500",
    height: "50px",
  },
  linkDiv: {
    width: "50%",
  },
  link: {
    cursor: "pointer",
    float: "right",
  },
  textBox: {
    textAlign: "center",
    fontSize: "40px",
    height: "30vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

const initialFormState = {
  email: "",
  password: "",
  newPassword: "",
  cpassword: "",
  formType: "signIn",
  OTP: "",
  user: {},
};

const Login = () => {
  const { login } = useContext(AuthContext);
  const history = useHistory();
  const [showPass, setShowPass] = useState({
    pass: false,
    cpass: false,
  });
  const [loading, setLoading] = useState(false);
  const [formType, setFormType] = useState("signIn");
  const [snackOpen, setSnackOpen] = useState({ open: false, message: "" });
  const [formState, updateFormState] = useState(initialFormState);
  const classes = useStyles();
  const [isValid, setIsValid] = useState({
    email: {
      valid: true,
      error: "",
    },
    password: {
      valid: true,
      error: "",
    },
    newPassword: {
      valid: true,
      error: "",
    },
    cpassword: {
      valid: true,
      error: "",
    },
    otp: {
      valid: true,
      error: "",
    },
  });
  const isValidHanlder = (name, value) => {
    let emailRegex = new RegExp("[a-zA-Z0-9]+@[a-zA-Z]+.[a-zA-Z]{2,3}");
    const otpRegex = new RegExp("^[0-9]{6}$");
    switch (name) {
      case "email":
        if (value.length < 3) {
          setIsValid({
            ...isValid,
            email: { valid: false, error: "Invalid Input!" },
          });
        } else if (!emailRegex.test(value)) {
          setIsValid({
            ...isValid,
            email: { valid: false, error: "Invalid Email!" },
          });
        } else {
          setIsValid({ ...isValid, email: { valid: true, error: "" } });
        }
        break;
      case "password":
        if (value.length < 3) {
          setIsValid({
            ...isValid,
            password: { valid: false, error: "Invalid Password!" },
          });
        } else if (value.length < 8) {
          setIsValid({
            ...isValid,
            password: {
              valid: false,
              error: "Password must be 8 character long!",
            },
          });
        } else {
          setIsValid({ ...isValid, password: { valid: true, error: "" } });
        }
        break;
      case "newPassword":
        if (value.length < 3) {
          setIsValid({
            ...isValid,
            newPassword: { valid: false, error: "Invalid Password!" },
          });
        } else if (value.length < 8) {
          setIsValid({
            ...isValid,
            newPassword: {
              valid: false,
              error: "Password must be 8 character long!",
            },
          });
        } else {
          setIsValid({ ...isValid, newPassword: { valid: true, error: "" } });
        }
        break;
      case "cpassword":
        if (value.length < 3) {
          setIsValid({
            ...isValid,
            cpassword: { valid: false, error: "Invalid Password!" },
          });
        } else if (value.length < 8) {
          setIsValid({
            ...isValid,
            cpassword: {
              valid: false,
              error: "Password must be 8 character long!",
            },
          });
        } else if (value !== formState.newPassword) {
          setIsValid({
            ...isValid,
            cpassword: { valid: false, error: "Password should be same!" },
          });
        } else {
          setIsValid({ ...isValid, cpassword: { valid: true, error: "" } });
        }
        break;
      case "OTP":
        if (value.length !== 6) {
          setIsValid({
            ...isValid,
            otp: { valid: false, error: "Invalid OTP!" },
          });
        } else if (!otpRegex.test(value)) {
          setIsValid({
            ...isValid,
            otp: { valid: false, error: "Invalid OTP!" },
          });
        } else {
          setIsValid({ ...isValid, otp: { valid: true, error: "" } });
        }
        break;
      default:
        return;
    }
  };

  function onChange(e) {
    isValidHanlder(e.target.name, e.target.value);
    updateFormState(() => ({ ...formState, [e.target.name]: e.target.value }));
  }

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const SnackOpenHandler = (message) => {
    setSnackOpen({ open: true, message });
  };

  const SnackCloseHandler = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen({ open: false, message: "" });
  };

  const checkValid = () => {
    if (
      formState.email.length < 1 ||
      formState.password.length < 1 ||
      !isValid.email.valid ||
      !isValid.password.valid
    ) {
      return false;
    } else {
      return true;
    }
  };
  const checkValidNewUser = () => {
    if (
      formState.newPassword.length < 1 ||
      formState.cpassword.length < 1 ||
      !isValid.newPassword.valid ||
      !isValid.cpassword.valid
    ) {
      return false;
    } else {
      return true;
    }
  };
  const checkValidOtp = () => {
    if (
      formState.OTP.length < 1 ||
      !isValid.otp.valid 
    ) {
      return false;
    } else {
      return true;
    }
  };

  const signIn = async (e) => {
    e.preventDefault();
    const { email, password } = formState;
    if (checkValid().valueOf(true)) {
      setLoading(true);
      console.log("user");
      Auth.signIn(email.toLowerCase(), password)
        .then((user) => {
          updateFormState({ ...formState, user: user });
          if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
            setFormType("challenge");
          } else if (
            user.challengeName === "SMS_MFA" ||
            user.challengeName === "SOFTWARE_TOKEN_MFA"
          ) {
            setFormType("Otp");
            console.log("user", user);
          } else if (
            user?.signInUserSession?.idToken?.payload &&
            user?.signInUserSession?.idToken?.payload["cognito:groups"] &&
            user?.signInUserSession?.idToken?.payload["cognito:groups"].length >
              0 &&
            user?.signInUserSession?.idToken?.payload["cognito:groups"][0] ===
              "admin"
          ) {
            login(user.signInUserSession.idToken.jwtToken);
            history.replace("/");
          } else {
            console.log("user2", user);
            SnackOpenHandler("You are not Authorized!");
          }
        })
        .catch((err) => {
          localStorage.clear();
          console.log("user", err);
          SnackOpenHandler(err.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      SnackOpenHandler("Invalid Username or password!");
    }
  };

  const challengePass = async (e) => {
    e.preventDefault();
    const { email, password, newPassword } = formState;
    if (checkValidNewUser().valueOf(true)) {
      setLoading(true);
      Auth.signIn(email.toLowerCase(), password)
        .then((user) => {
          if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
            Auth.completeNewPassword(
              user, // the Cognito User Object
              newPassword // the new password
            )
              .then((user) => {
                setLoading(false);
                login(user?.signInUserSession?.idToken?.jwtToken);
                history.replace("/");
              })
              .catch((e) => {
                SnackOpenHandler(e.message);
              });
          } else {
            setFormType("signIn");
          }
        })
        .catch((e) => {
          SnackOpenHandler(e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      SnackOpenHandler("Invalid Password!");
    }
  };
  const challengeOtpPass = async (e) => {
    e.preventDefault();
    const { OTP, user } = formState;
    if (checkValidOtp().valueOf(true)) {
      setLoading(true);
      console.log("form use state", user);
      if (
        user.challengeName === "SMS_MFA" ||
        user.challengeName === "SOFTWARE_TOKEN_MFA"
      ) {
        Auth.confirmSignIn(user, OTP, "SMS_MFA")
          .then((user1) => {
            console.log("form use state", user1);
            setLoading(false);
            login(user?.signInUserSession?.idToken?.jwtToken);
            history.replace("/");
          })
          .catch((e) => {
            setLoading(false);
            console.log("error",e.message)
            if(e.message === "Invalid code or auth state for the user."){
              SnackOpenHandler("Invalid code");
            }else{
              SnackOpenHandler(e.message);
            }
            
          });
      } else {
        setFormType("signIn");
      }
    } else {
      SnackOpenHandler("Invalid OTP!");
    }
  };

  return (
    <>
      {formType === "signIn" && (
        <Grid container>
          <Grid item sm={12} xs={12} md={6} lg={6}>
            <Typography className={classes.textBox}>
              Hello Admin
              <br />
              Welcome Back
            </Typography>
            <form
              onSubmit={signIn}
              className={classes.form}
              noValidate
              autoComplete="off"
            >
              <TextField
                className={classes.input}
                label="Email"
                type="text"
                name="email"
                inputProps={{
                  "aria-label": "email",
                }}
                onChange={onChange}
                error={!isValid.email.valid}
                helperText={!isValid.email.valid && isValid.email.error}
                variant="outlined"
                required
                autoComplete="email"
              />
              <TextField
                className={classes.input}
                label="Password"
                type={showPass.pass ? "text" : "password"}
                name="password"
                onChange={onChange}
                inputProps={{
                  "aria-label": "password",
                }}
                variant="outlined"
                error={!isValid.password.valid}
                helperText={!isValid.password.valid && isValid.password.error}
                required
                autoComplete="off"
                InputProps={{
                  endAdornment: formState.password.length > 0 && (
                    <InputAdornment classes={classes.inputIcon} position="end">
                      {!showPass.pass ? (
                        <VisibilityOutlined
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setShowPass({ ...showPass, pass: true })
                          }
                        />
                      ) : (
                        <VisibilityOffOutlined
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setShowPass({ ...showPass, pass: false })
                          }
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
              />
              <div className={classes.linkDiv}>
                <Link to="/forgot-password" className={classes.link}>
                  Forgot Password?
                </Link>
              </div>

              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                type="submit"
                aria-label="loginButton"
              >
                Login
              </Button>
              <Snackbar
                open={snackOpen.open}
                autoHideDuration={6000}
                onClose={SnackCloseHandler}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              >
                <Alert onClose={SnackCloseHandler} severity="error">
                  {snackOpen.message}
                </Alert>
              </Snackbar>
            </form>
          </Grid>
          <Grid item lg={6} md={6}>
            <Box display={{ xs: "none", md: "block", lg: "block" }}>
              <img
                className={classes.img}
                src="https://images.unsplash.com/photo-1616277434251-0e5188ccbe00?ixid=MXwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                alt="images"
              />
            </Box>
          </Grid>
        </Grid>
      )}
      {formType === "challenge" && (
        <Grid container>
          <Grid item sm={12} xs={12} md={6} lg={6}>
            <Typography className={classes.textBox}>
              Enter a New Password
            </Typography>
            <form
              onSubmit={challengePass}
              className={classes.form}
              noValidate
              autoComplete="off"
            >
              <TextField
                className={classes.input}
                value={formState.email}
                disabled
                type="text"
                inputProps={{
                  "aria-label": "email",
                }}
                onChange={onChange}
                variant="outlined"
                required
              />
              <TextField
                className={classes.input}
                label="New Passsword"
                type={showPass.pass ? "text" : "password"}
                name="newPassword"
                onChange={onChange}
                error={!isValid.newPassword.valid}
                helperText={
                  !isValid.newPassword.valid && isValid.newPassword.error
                }
                variant="outlined"
                inputProps={{
                  "aria-label": "newPassword",
                }}
                required
                autoComplete="email"
                InputProps={{
                  endAdornment: formState.newPassword.length > 0 && (
                    <InputAdornment classes={classes.inputIcon} position="end">
                      {!showPass.pass ? (
                        <VisibilityOutlined
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setShowPass({ ...showPass, pass: true })
                          }
                        />
                      ) : (
                        <VisibilityOffOutlined
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setShowPass({ ...showPass, pass: false })
                          }
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                className={classes.input}
                label="Confirm Password"
                type={showPass.cpass ? "text" : "password"}
                name="cpassword"
                onChange={onChange}
                variant="outlined"
                error={!isValid.cpassword.valid}
                helperText={!isValid.cpassword.valid && isValid.cpassword.error}
                required
                inputProps={{
                  "aria-label": "cNewPassword",
                }}
                autoComplete="off"
                InputProps={{
                  endAdornment: formState.cpassword.length > 0 && (
                    <InputAdornment classes={classes.inputIcon} position="end">
                      {!showPass.cpass ? (
                        <VisibilityOutlined
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setShowPass({ ...showPass, cpass: true })
                          }
                        />
                      ) : (
                        <VisibilityOffOutlined
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setShowPass({ ...showPass, cpass: false })
                          }
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                type="submit"
                aria-label="loginNewButtton"
              >
                Login
              </Button>
              <Snackbar
                open={snackOpen.open}
                autoHideDuration={6000}
                onClose={SnackCloseHandler}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              >
                <Alert onClose={SnackCloseHandler} severity="error">
                  {snackOpen.message}
                </Alert>
              </Snackbar>
            </form>
          </Grid>
          <Grid item lg={6} md={6}>
            <Box display={{ xs: "none", md: "block", lg: "block" }}>
              <img
                className={classes.img}
                src="https://images.unsplash.com/photo-1616277434251-0e5188ccbe00?ixid=MXwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                alt="images"
              />
            </Box>
          </Grid>
        </Grid>
      )}
      {formType === "Otp" && (
        <Grid container>
          <Grid item sm={12} xs={12} md={6} lg={6}>
            <Typography className={classes.textBox}>Enter OTP</Typography>
            <form
              onSubmit={challengeOtpPass}
              className={classes.form}
              noValidate
              autoComplete="off"
            >
              <TextField
                className={classes.input}
                label="OTP"
                type={showPass.pass ? "text" : "password"}
                name="OTP"
                onChange={onChange}
                error={!isValid.otp.valid}
                helperText={
                  !isValid.otp.valid && isValid.otp.error
                }
                variant="outlined"
                inputProps={{
                  "aria-label": "otp",
                }}
                required
                autoComplete="otp"
                InputProps={{
                  endAdornment: formState.OTP.length > 0 && (
                    <InputAdornment classes={classes.inputIcon} position="end">
                      {!showPass.pass ? (
                        <VisibilityOutlined
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setShowPass({ ...showPass, pass: true })
                          }
                        />
                      ) : (
                        <VisibilityOffOutlined
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setShowPass({ ...showPass, pass: false })
                          }
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                type="submit"
                aria-label="loginNewButtton"
              >
                Verify
              </Button>
              <Snackbar
                open={snackOpen.open}
                autoHideDuration={6000}
                onClose={SnackCloseHandler}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              >
                <Alert onClose={SnackCloseHandler} severity="error">
                  {snackOpen.message}
                </Alert>
              </Snackbar>
            </form>
          </Grid>
          <Grid item lg={6} md={6}>
            <Box display={{ xs: "none", md: "block", lg: "block" }}>
              <img
                className={classes.img}
                src="https://images.unsplash.com/photo-1616277434251-0e5188ccbe00?ixid=MXwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                alt="images"
              />
            </Box>
          </Grid>
        </Grid>
      )}
      {loading && <LoadingScreen loading={loading} />}
    </>
  );
};

export default withRouter(Login);